import { useTranslation } from '@/i18n/hook';
import { Link } from 'react-router-dom';
import { pillarArticles } from '@/mocks/articles';

export default function PillarArticles() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const get = (l: { pt: string; en: string; de: string }) => {
    if (currentLang === 'de') return l.de;
    if (currentLang === 'en') return l.en;
    return l.pt;
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-4">
          {t('pillar.h2')}
        </h2>
        <p className="text-foreground-600 text-center max-w-2xl mx-auto mb-10">
          {t('pillar.subtitle')}
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {pillarArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all flex flex-col"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={get(article.title)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="inline-block self-start px-2.5 py-1 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full mb-3">
                  {get(article.category)}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 leading-snug group-hover:text-primary-700 transition-colors">
                  {get(article.title)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {get(article.meta)}
                </p>
                <span className="mt-auto inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 whitespace-nowrap">
                  {t('pillar.read')}
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}